var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusExpiredFolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.5,
    height: 34.5,
    viewBox: "0 0 34.5 34.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Expired",
    transform: "translate(-806 -1237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1838",
    d: "M0 0H34.5V34.5H0z",
    className: "cls-1",
    transform: "translate(806 1237)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_pending_review",
    transform: "translate(807.569 1240.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    d: "M0 27.052V2.7A2.706 2.706 0 0 1 2.7 0h21.649a2.706 2.706 0 0 1 2.7 2.7v7.232a8.117 8.117 0 0 0-9.734 11.71H5.41L0 27.051z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "alarm-24px",
    transform: "translate(17.837 10.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4285",
    d: "M0 0h14.375v14.375H0z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4286",
    d: "M13.979 4.172L11.224 1.86l-.773.916 2.755 2.312zm-8.457-1.4l-.767-.912L2 4.166l.773.916zm2.767 2.766h-.9v3.593l2.845 1.707.449-.737-2.4-1.42zm-.3-2.4a5.391 5.391 0 1 0 5.391 5.394 5.391 5.391 0 0 0-5.39-5.39zm0 9.583a4.193 4.193 0 1 1 4.193-4.193 4.19 4.19 0 0 1-4.192 4.197z",
    transform: "translate(-0.802 -0.746)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusExpiredFolder);
export default __webpack_public_path__ + "static/media/status-expired-folder.3d44205c650b42c6ed27ec4fd008f796.svg";
export { ForwardRef as ReactComponent };